module.exports = __webpack_public_path__ + "img/btn03.3e67d20c.png";